import React from 'react';
import Navbar from './components/Navbar';
import './App.css';

import {Router, Switch, Route } from 'react-router-dom';
import history from './history';
import Home from './components/pages/Home';
import Plan from './components/pages/Plan';

import Zdroje from './components/pages/Zdroje';
import Download from './components/pages/Download';


function App() {
  return (
    <>
      <Router history={history}>
        <Navbar />
        <Switch>
          <Route path='/~krempaska21/' exact component = {Home}/>
          <Route path='/~krempaska21/plan' exact component = {Plan}/>
          <Route path= '/~krempaska21/zdroje' exact component = {Zdroje} />
          <Route path = '/~krempaska21/downloads' exact component = {Download} />
        </Switch>
      </Router>
    </>
  );
}

export default App;